/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { Tooltip } from "src/components/UI/Tooltip";

export const SourceIcon = () => {
  return (
    <StyledSourceIcon>
      <Tooltip tooltipText="Origin" delayShow={500}>
        [*]
      </Tooltip>
    </StyledSourceIcon>
  );
};

const StyledSourceIcon = styled.div`
  position: absolute;
  bottom: 12px;
  right: 8px;
  color: inherit;
`;
